import React, { useEffect, useState } from "react";
import { MenuItem, Select, Checkbox, ListItemText, FormControl, InputLabel, SelectChangeEvent, IconButton, Popover, List, ListItem } from "@mui/material";
import { BuildingDTO } from "../../../../../ApiOld/Api/ApiServerVov";
import { FilterList } from "@mui/icons-material";


interface BuildingFilterProps {
  buildings: BuildingDTO[];
  onFilterChange: (selectedBuildings: BuildingDTO[]) => void;
  selectedBuildings: BuildingDTO[];
}

const BuildingFilterSelect: React.FC<BuildingFilterProps> = ({ buildings, onFilterChange, selectedBuildings }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleChange = (building: BuildingDTO) => {
    const newSelected = selectedBuildings.includes(building)
      ? selectedBuildings.filter(b => b.id !== building.id)
      : [...selectedBuildings, building];
    onFilterChange(newSelected);
  };

  return (
    <FormControl fullWidth>
      <IconButton onClick={handleClick}>
        <FilterList />
      </IconButton>
      <Popover
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <List>
          {buildings.map((building) => (
            <ListItem onClick={() => handleChange(building)}>
              <Checkbox checked={selectedBuildings.includes(building)} />
              <ListItemText primary={building.name} />
            </ListItem>
          ))}
        </List>
      </Popover>
    </FormControl>
  );
};

export default BuildingFilterSelect;
